import React, { useState } from 'react'
import { Accordion, Button, ListGroup } from 'react-bootstrap'
import styled from 'styled-components'

import AccordionDown from '../../assets/img/icons/accordion-down.svg'
import AccordionUp from '../../assets/img/icons/accordion-up.svg'
import pricing from '../../data/pricing'
import { themeColors } from '../../helpers/themeColors'
import { isIframed, joinClasses } from '../../helpers/utils'

const colors = themeColors()

const ContainerStyle = styled.div`
  padding-top: 17px;
  padding-bottom: 34px;
  padding-left: 1rem;
  padding-right: 1rem;
  @media screen and (min-width: 768px) {
    padding-left: 48px;
    padding-right: 48px;
  }
`

const PriceItem = styled(ListGroup.Item)`
  border-bottom-color: ${colors.mediumGray};
  :last-child {
    border-bottom-width: 1px;
  }
`

const PriceInnerItem = styled(ListGroup.Item)`
  border-bottom-color: ${colors.mediumGray};
  padding: 8px 24px !important;
  margin-bottom: 8px;
  :nth-child(odd) {
    background: #4f4f4f;
  }
  :last-child {
    margin-bottom: 0;
  }
`

const MARKETINGSITE = process.env.REACT_APP_MARKETING_SITE_URL

const Pricing = () => {
  const [active, setActive] = useState('express-services')
  const handleSelect = (val) => {
    setActive(val)
  }

  const handleGoPricingPage = (e) => {
    e.preventDefault()
    if (isIframed) {
      window.parent.postMessage({ redirect: 'pricing' }, MARKETINGSITE)
    } else {
      window.location.href = `${MARKETINGSITE}/pricing`
    }
  }

  const handleClickPrice = (e, service) => {
    e.preventDefault()
    console.log(service)
    if (service.link) {
      if (isIframed) {
        window.parent.postMessage({ redirect: service }, MARKETINGSITE)
      } else {
        window.location.href = `${MARKETINGSITE}${service}`
      }
    }
  }

  return (
    <ContainerStyle>
      <Accordion activeKey={active} onSelect={handleSelect}>
        <ListGroup variant="flush">
          {pricing.map((price) => (
            <PriceItem key={price.id} className="p-0">
              <div className="d-flex flex-grow-1 min-width-zero">
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  eventKey={price.id}
                  className={joinClasses([
                    price.id === active ? 'bolder' : '',
                    'card-body justify-content-start text-big border-0 shadow-none btn-pure-link my-4 text-white',
                  ])}
                >
                  {price.label}
                  <img
                    src={price.id === active ? AccordionUp : AccordionDown}
                    alt={`Toggle ${price.label}`}
                    className="ml-auto mr-32px"
                  />
                </Accordion.Toggle>
              </div>
              <Accordion.Collapse eventKey={price.id}>
                <ListGroup className="mb-48px list-group-lg text-body-bigger text-white">
                  {price.data.map((service) => (
                    <PriceInnerItem
                      key={service.name}
                      className="border-0 d-flex align-items-center"
                    >
                      {service.label}
                      <div
                        onClick={(e) => handleClickPrice(e, service.link)}
                        className="btn btn-primary btn-lg ml-auto"
                      >
                        {service.price}
                      </div>
                    </PriceInnerItem>
                  ))}
                </ListGroup>
              </Accordion.Collapse>
            </PriceItem>
          ))}
        </ListGroup>
      </Accordion>
      <Button onClick={handleGoPricingPage} className="d-flex ml-auto">
        Go to all pricing page
      </Button>
    </ContainerStyle>
  )
}

export default Pricing
